import { color } from "src/styles/globals";
import styled from "styled-components";

export const Container = styled.div`
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const ListContainer = styled.ul`
  color: ${color.tigerOrange03};
  gap: 16px;
  display: flex;
  flex-direction: column;
  padding-left: 24px;
`;
